<div class="w-full px-4">
  <div class="w-full flex flex-column gap-3">
    <div class="grid align-items-center justify-content-between">
      <h1 class="text-left col font-bold text-2xl md:text-4xl">Peer List</h1>
      <div class="col-auto">
        <p-button icon="pi pi-user-plus" (click)="addPeer()" label="Add Admin" styleClass="submitBtn"
          [style]="{width: 'auto', 'white-space': 'nowrap'}" />
      </div>
    </div>
    <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
      <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
      <div class="grid">
        <form [formGroup]="filterForm" (ngSubmit)="getPeersCombined(1)" class="w-full flex flex-wrap">
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">From Date</b>
            <p-calendar placeholder="From date" formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true"
              inputId="icondisplay" class="w-full" styleClass="fullWidth" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">To Date</b>
            <p-calendar placeholder="To Date" formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true"
              inputId="icondisplay" class="w-full" styleClass="fullWidth" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">State</b>
            <p-dropdown [options]="peerStateOptions" styleClass="selectFull" class="w-full" optionLabel="name"
              optionValue="value" formControlName="status" filterBy="name" [showClear]="true" appendTo="body"
              placeholder="Select Peer-State">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ option.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Admin Name</b>
            <p-autoComplete formControlName="adminNameId" [suggestions]="adminNames"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('adminNameId')?.value}" class="w-full"
              (completeMethod)="filterAdminNames($event)" styleClass="fullWidth" optionValue="name" optionLabel="name"
              (onSelect)="onAdminSelect($event)">
            </p-autoComplete>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Peer Name</b>
            <p-autoComplete formControlName="peerName" [suggestions]="peerNames"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('peerName')?.value}" class="w-full"
              (completeMethod)="filterPeerNames($event)" styleClass="fullWidth" optionValue="name" optionLabel="name">
            </p-autoComplete>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">College/University</b>
            <p-autoComplete formControlName="collegeName" [suggestions]="searchAutoCompleteInstitutes"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('collegeName')?.value}" class="w-full"
              [showClear]="true" (completeMethod)="filterInstitutes($event)" styleClass="fullWidth" optionValue="name"
              optionLabel="name">
            </p-autoComplete>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Country</b>
            <p-dropdown [options]="countries" styleClass="selectFull" class="w-full" optionLabel="name"
              optionValue="name" formControlName="country" [filter]="true" filterBy="name" [showClear]="true"
              appendTo="body" placeholder="Select a Country">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-country pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ country.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Field Of Study</b>
            <input type="text" formControlName="fieldOfStudy" pInputText class="w-full" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="font-regular text-base" style="color: #505050;">Level Of Study</b>
            <p-dropdown [options]="degreePrefs" styleClass="selectFull" optionValue="key" [showClear]="true"
              [ngClass]="{'ng-invalid ng-dirty' : submitted && ! filterForm.get('levelOfStudy')?.value}"
              formControlName="levelOfStudy" optionLabel="name" class="w-full" placeholder="Select a Course" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <div class="w-full" style="padding-top: 27px;">
              <p-button type="submit" label="Search" class="w-full" styleClass="submitBtn" />
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="w-full">
      <p-table *ngIf="peerList && peerList.length > 0; else noRecordsFound" [value]="peerList"
        [paginator]="peerList.length!=totalRecords" [rows]="rowSize" [totalRecords]="totalRecords"
        [showCurrentPageReport]="true" [first]="first" [lazy]="true" [lazyLoadOnInit]="false" [loading]="isLoading"
        [loadingIcon]="'pi pi-spinner'" (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]"
        [showPageLinks]="true" styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Peer Name</th>
            <th>Gender</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Country</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-peer>

          <tr>
            <td>{{peer.firstName}} {{peer.lastName}}</td>
            <td>{{genderDescriptions(peer.gender)}}</td>
            <td>{{peer.email}}</td>
            <td>{{peer.phoneNumber}}</td>
            <td>{{peer.country}}</td>

            <td>
              <div class="w-auto inline-flex align-items-center gap-2">
                <p-button class="px-2" label="Edit" icon="pi pi-pen-to-square" styleClass="w-7rem viewapplication"
                  (click)="editPeerDetails(peer.applicationUserId)" />
                <p-button class="px-2" label="Manage Time-Slots" icon="pi pi-plus-circle" styleClass="viewapplication"
                  (click)="viewProfile(peer.applicationUserId)" />

                <p-button *ngIf="shouldShowAcceptButton(peer)" class="px-2" label="Accept" icon="pi pi-check"
                  [loading]="updatingState[peer.applicationUserId]" styleClass="accept" (click)="acceptPeer(peer)" />
                <p-button *ngIf="shouldShowRejectButton(peer)" class="px-2" label="Reject" icon="pi pi-times"
                  [loading]="updatingState[peer.applicationUserId]" styleClass="reject" (click)="rejectPeer(peer)" />
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template #noRecordsFound>
        <div class="w-full flex flex-column align-items-center py-4 gap-5">
          <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
          </div>
          <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
        </div>
      </ng-template>
    </div>
  </div>
</div>